import fetch from '@/api/fetch'

// 生成年龄的面容
export const postForNewCreateFace = data => fetch(`/api/v1/hd/face/gen/image/max100`, data, 'post')

// 生成mp4
export const postForCreateMp4 = data => fetch(`/api/v1/hd/face/compose/all/max100`, data, 'post')

// 生成下载二维码
export const createQrCodeForDown = (siteID, hash) => fetch(`/api/v1/hd/user/download/qrcode/${siteID}/${hash}`)

// 所有内容分组
export const getAllContentGroups = () => fetch(`/api/v1/hd/contentgroups`, null, 'get')

// 内容分组
export const getContents = (contentGroupId, pageNo) =>
  fetch(`/api/v1/hd/contents?contentGroupId=${contentGroupId}&pageSize=8&pageNo=${pageNo}`, null, 'get')

// 内容
export const getContent = id => fetch(`/api/v1/hd/contents/${id}`, null, 'get')

// 获取登录二维码
export const getLoginQrCode = siteID => fetch(`/api/v1/hd/user/login/qrcode/${siteID}`)

// 生成数字人视频
export const getDigiCreateMp4 = data => fetch(`/api/v1/hd/staffvideos`, data, 'get')
// 网点
export const getSite = id => fetch(`/api/v1/hd/sites/${id}`, null, 'get')

// 语音识别
export const getAliAsrToken = () => fetch('/api/v1/hd/asr/token')

// 保存录音
export const saveRecord = data => fetch(`/api/v1/hd/recorder`, data, 'post')
export const getRecorderQrcode = (siteID, id) => fetch(`/api/v1/hd/recorder/qrcode/${siteID}/${id}`)

// 养老金step配置信息
export const getPensionStepInfo = siteID => fetch(`/api/v1/hd/pensiongap/configinfo?siteID=${siteID}`)

// cms轮播图
export const getBannerForConfigCMS = () => fetch('/api/v1/hd/sysconfig/cms')

export default {
  postForNewCreateFace,
  postForCreateMp4,
  createQrCodeForDown,
  getAllContentGroups,
  getContents,
  getContent,
  getLoginQrCode,
  getDigiCreateMp4,
  getPensionStepInfo,
  getSite,
  getBannerForConfigCMS
}
